import React from "react";
import { ShieldAlert } from "lucide-react";

export function FooterDisclaimer() {
  return (
    <div
      data-testid="footer-disclaimer"
      className="mt-12 pt-6 border-t border-border text-xs text-muted-foreground flex items-start gap-2 max-w-3xl"
    >
      <ShieldAlert className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <p>
        <span className="font-semibold text-foreground">Surgeon.ai</span> — AI-Assisted Decision Support Tool.
        All recommendations require independent surgeon review before clinical application.
      </p>
    </div>
  );
}
